<script>
    import { createEventDispatcher, onMount, beforeUpdate } from "svelte";
    import { writable, get } from "svelte/store";
    import { theme } from "$stores/themeStore";

    const dispatch = createEventDispatcher();
    export let showForm = false;
    export let scheduleItems = [];
    export let selectedScheduleId = null;
    let isWaiting = false;

    // onMount(async () => {
    //     console.info("WeightForm scheduleItems: " + scheduleItems);
    //     console.info("WeightForm selectedScheduleId: " + selectedScheduleId);
    // });

    let weightData = writable({
        externalId: "10000001465457",
        manufacturer: "seca",
        model: "554",
        protocolNumber: "SECA001",
        raw: "",
        read: "2024-08-10T18:14:34.045-0700",
        received: "2024-08-10T18:14:34.045-0700",
        subjectActivityGUID: selectedScheduleId,
        subjectGUID: null,
        timezone: "America/Los_Angeles",
        unit: "KG",
        value: 74.5,
    });

    $: if (showForm) {
        resetWeightData();
    }

    function resetWeightData() {
        weightData.set({
            externalId: "10000001465457",
            manufacturer: "seca",
            model: "554",
            protocolNumber: "SECA001",
            raw: "",
            read: "2024-08-10T18:14:34.045-0700",
            received: "2024-08-10T18:14:34.045-0700",
            subjectActivityGUID: selectedScheduleId,
            subjectGUID: null,
            timezone: "America/Los_Angeles",
            unit: "KG",
            value: 74.5,
        });
    }

    function close() {
        dispatch("close");
    }

    async function handleSubmit() {
        isWaiting = true; // Set waiting state to true
        weightData.set({
            externalId: "10000001465457",
            manufacturer: "seca",
            model: "554",
            protocolNumber: "SECA001",
            raw: "",
            read: "2024-08-10T18:14:34.045-0700",
            received: "2024-08-10T18:14:34.045-0700",
            subjectActivityGUID: selectedScheduleId,
            subjectGUID: null,
            timezone: "America/Los_Angeles",
            unit: "KG",
            value: 74.5,
        });
        // Simulate waiting for a few seconds
        await new Promise((resolve) => setTimeout(resolve, 5000));

        const weight = get(weightData);
        dispatch("submit", weight);

        isWaiting = false; // Reset waiting state
        close(); // Close the dialog
    }
</script>

{#if showForm}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div
        class="fixed inset-0 z-[998] flex items-center justify-center backdrop-blur-sm"
    >
        <div class="modal-overlay absolute inset-0 bg-slate-800 opacity-75" on:click={close}></div>
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div
            class="bg-white dark:bg-gray-900 p-4 rounded-lg shadow-lg w-full max-w-2xl relative z-[999]"
            on:click|stopPropagation
        >
            <header class="flex justify-between items-start mb-4">
                <h2 class="text-xl font-bold text-gray-900 dark:text-gray-100">
                    New Measurement
                </h2>
                <button
                    on:click={close}
                    class="text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200"
                >
                    &times;
                </button>
            </header>
            <form on:submit|preventDefault={handleSubmit} class="space-y-4">
                <div class="flex flex-col items-center gap-3 pt-5">
                    <p
                        class="font-light text-m text-center pt-5 text-gray-900 dark:text-gray-100 opacity-50"
                    >
                        To start the measurement select a visit<br />then click
                        the button.
                    </p>
                </div>

                <div class="flex gap-3 pt-5 justify-center">
                    <div class="w-1/3">
                        <label
                            for="deviceId"
                            class="block text-xs pb-1 text-gray-700 dark:text-gray-200 opacity-50"
                            >Scale</label
                        >
                        <label
                            for="deviceId"
                            class="block text-xl pb-1 text-gray-700 dark:text-gray-200"
                            >10000001465457</label
                        >
                    </div>

                    <div class="w-1/3">
                        <label
                            for="scheduleItem"
                            class="block text-xs pb-1 text-gray-700 dark:text-gray-200 opacity-50"
                            >Visit</label
                        >
                        <select
                            id="scheduleItem"
                            bind:value={$weightData.selectedScheduleId}
                            class="border p-1 w-full rounded dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
                        >
                            <option value="" disabled selected
                                >Select</option
                            >
                            {#each scheduleItems as item}
                                <option value={item._id}>{item.name}</option>
                            {/each}
                        </select>
                    </div>
                </div>

                <!-- <div class="flex gap-3 pt-5 justify-center">
                    <div class="w-1/3">
                        <label
                            for="externalId"
                            class="block text-xs pb-1 text-gray-700 dark:text-gray-200 opacity-50"
                            >Height (cm)</label
                        >
                        <input
                            type="text"
                            id="externalId"
                            bind:value={$weightData.height}
                            class="border p-1 w-full rounded dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
                            required
                        />
                    </div>
                </div> -->

                {#if $weightData.weight}
                    <div class="flex gap-3 pt-5 justify-center">
                        <div class="w-1/4">
                            <label
                                for="weight"
                                class="block text-xs pb-1 text-gray-700 dark:text-gray-200 opacity-50"
                                >Weight (KG)</label
                            >
                            <label
                                for="weight"
                                class="block text-xl pb-1 text-gray-700 dark:text-gray-200"
                                >{$weightData.weight}</label
                            >
                        </div>
                        <div class="w-1/4">
                            <label
                                for="bmi"
                                class="block text-xs pb-1 text-gray-700 dark:text-gray-200 opacity-50"
                                >BMI</label
                            >
                            <label
                                for="bmi"
                                class="block text-xl pb-1 text-gray-700 dark:text-gray-200"
                                >{$weightData.bmi}</label
                            >
                        </div>
                        <div class="w-1/4">
                            <label
                                for="fatMass"
                                class="block text-xs pb-1 text-gray-700 dark:text-gray-200 opacity-50"
                                >Fat Mass (KG)</label
                            >
                            <label
                                for="fatMass"
                                class="block text-xl pb-1 text-gray-700 dark:text-gray-200"
                                >{$weightData.fatMass}</label
                            >
                        </div>
                        <div class="w-1/4">
                            <label
                                for="totalBodyWater"
                                class="block text-xs pb-1 text-gray-700 dark:text-gray-200 opacity-50"
                                >Total Body Water (KG)</label
                            >
                            <label
                                for="totalBodyWater"
                                class="block text-xl pb-1 text-gray-700 dark:text-gray-200"
                                >{$weightData.totalBodyWater}</label
                            >
                        </div>
                    </div>
                {/if}

                <div class="flex justify-center space-x-2 pt-10">
                    <button
                        type="submit"
                        class="bg-blue-500 text-white py-1 px-2 mb-6 rounded hover:bg-blue-700 flex items-center"
                        disabled={isWaiting}
                    >
                        {#if isWaiting}
                            <span class="loader mr-2"></span>
                            Waiting for Measurement...
                        {:else}
                            Request Measurement
                        {/if}
                    </button>
                </div>

                <!-- Add the following CSS for a simple loader animation -->
                <style>
                    .loader {
                        border: 2px solid #f3f3f3;
                        border-radius: 50%;
                        border-top: 2px solid #3498db;
                        width: 16px;
                        height: 16px;
                        animation: spin 1s linear infinite;
                    }

                    @keyframes spin {
                        0% {
                            transform: rotate(0deg);
                        }
                        100% {
                            transform: rotate(360deg);
                        }
                    }
                </style>
            </form>
        </div>
    </div>
{/if}
